/**
 * Monthly recurrence configuration component - Outlook style
 */
export function MonthlyRecurrenceConfig({ recurrence, onChange }) {
  const weekOptions = [
    { value: 'first', label: 'Ersten' },
    { value: 'second', label: 'Zweiten' },
    { value: 'third', label: 'Dritten' },
    { value: 'fourth', label: 'Vierten' },
    { value: 'last', label: 'Letzten' }
  ];

  const dayOptions = [
    { value: 0, label: 'Sonntag' },
    { value: 1, label: 'Montag' },
    { value: 2, label: 'Dienstag' },
    { value: 3, label: 'Mittwoch' },
    { value: 4, label: 'Donnerstag' },
    { value: 5, label: 'Freitag' },
    { value: 6, label: 'Samstag' }
  ];

  const updateMonthlyPattern = (field, value) => {
    onChange({
      ...recurrence,
      monthlyPattern: {
        ...(recurrence.monthlyPattern || { week: 'first', dayOfWeek: 1 }),
        [field]: value
      }
    });
  };

  return (
    <div className="recurrence-config">
      <div className="form-group">
        <label>Alle wie viele Monate?</label>
        <input
          type="number"
          min="1"
          max="12"
          value={recurrence.interval || 1}
          onChange={(e) => onChange({ ...recurrence, interval: parseInt(e.target.value) })}
          style={{ width: '100px' }}
        />
        <span className="input-suffix">Monat(e)</span>
      </div>

      <div className="form-row form-row-2">
        <div className="form-group">
          <label>Am *</label>
          <select
            value={recurrence.monthlyPattern?.week || 'first'}
            onChange={(e) => updateMonthlyPattern('week', e.target.value)}
            required
          >
            {weekOptions.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Wochentag *</label>
          <select
            value={recurrence.monthlyPattern?.dayOfWeek ?? 1}
            onChange={(e) => updateMonthlyPattern('dayOfWeek', parseInt(e.target.value))}
            required
          >
            {dayOptions.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="form-row form-row-2">
        <div className="form-group">
          <label>Startdatum *</label>
          <input
            type="date"
            value={recurrence.startDate}
            onChange={(e) => onChange({ ...recurrence, startDate: e.target.value })}
            required
          />
        </div>

        <div className="form-group">
          <label>Enddatum (optional)</label>
          <input
            type="date"
            value={recurrence.endDate || ''}
            onChange={(e) => onChange({ ...recurrence, endDate: e.target.value || null })}
            min={recurrence.startDate}
          />
        </div>
      </div>
    </div>
  );
}
